import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import moment from 'moment'

export function mapStateToProps(state, hocProps) {
    const contentId = hocProps.id || null

    const user = state.getIn(['authorization', 'user'], Map())
    const license = {
        name: state.getIn(['authorization', 'license', 'licenceName'], 0),
        end: state.getIn(['authorization', 'license', 'licEndDt'], 0),
        start: state.getIn(['authorization', 'license', 'licStrtDt'], 0),
    }
    const loadedContentData = state.getIn(['ui', 'userProfile', 'content', 'contents', contentId, 'data'], Map())

    return {
        isLoading: state.getIn(['ui', 'userProfile', 'content', 'contents', contentId, 'isLoading'], false),
        user: {
            name: `${user.get('firstName', '')} ${user.get('lastName', '')}`,
            email: user.get('email', ''),
        },
        license: {
            ...license,
            remainDays: moment(license.end).diff(moment(), 'days'),
            usedDays: moment().diff(moment(license.start), 'days'),
            totalDays: moment(license.end).diff(moment(license.start), 'days'),
        },
        report: loadedContentData.get('report', null)
            ? {
                  value: loadedContentData.getIn(['report', 'value']),
                  total: loadedContentData.getIn(['report', 'total']),
                  period: loadedContentData.getIn(['report', 'period']),
              }
            : null,
        linkages: loadedContentData.get('linkages', null)
            ? {
                  value: loadedContentData.getIn(['linkages', 'value']),
                  total: loadedContentData.getIn(['linkages', 'total']),
                  period: loadedContentData.getIn(['linkages', 'period']),
              }
            : null,
        monitoring: loadedContentData.get('monitoring', null)
            ? {
                  subjects: {
                      value: loadedContentData.getIn(['monitoring', 'subjects', 'value']),
                      total: loadedContentData.getIn(['monitoring', 'subjects', 'total']),
                  },
                  groups: {
                      value: loadedContentData.getIn(['monitoring', 'groups', 'value']),
                      total: loadedContentData.getIn(['monitoring', 'groups', 'total']),
                  },
              }
            : null,
        portfolio: loadedContentData.get('portfolio', null)
            ? {
                  value: loadedContentData.getIn(['portfolio', 'value']),
                  total: loadedContentData.getIn(['portfolio', 'total']),
                  name: loadedContentData.getIn(['portfolio', 'name']),
              }
            : null,
        distraints: loadedContentData.get('distraints', null)
            ? {
                  cz: {
                      moneyLeft: loadedContentData.getIn(['distraints', 'cz', 'moneyLeft']),
                      moneyLeftCurrency: loadedContentData.getIn(['distraints', 'cz', 'moneyLeftCurrency']),
                      pricePerQuery: loadedContentData.getIn(['distraints', 'cz', 'pricePerQuery']),
                      pricePerQueryCurrency: loadedContentData.getIn(['distraints', 'cz', 'pricePerQueryCurrency']),
                      queriesLeft: loadedContentData.getIn(['distraints', 'cz', 'queriesLeft']),
                      validTo: loadedContentData.getIn(['distraints', 'cz', 'validTo']),
                  },
                  sk: {
                      moneyLeft: loadedContentData.getIn(['distraints', 'sk', 'moneyLeft']),
                      moneyLeftCurrency: loadedContentData.getIn(['distraints', 'sk', 'moneyLeftCurrency']),
                      pricePerQuery: loadedContentData.getIn(['distraints', 'sk', 'pricePerQuery']),
                      pricePerQueryCurrency: loadedContentData.getIn(['distraints', 'sk', 'pricePerQueryCurrency']),
                      queriesLeft: loadedContentData.getIn(['distraints', 'sk', 'queriesLeft']),
                      validTo: loadedContentData.getIn(['distraints', 'sk', 'validTo']),
                  },
              }
            : null,
    }
}

export default (InnerComponent) => {
    @connect(mapStateToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
